/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditProfileDescribeRequest extends models.RequestAuditBaseRequest {
    getFixupPrototypeFunction() { return RequestAuditProfileDescribeRequest.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditProfileDescribeRequest>): RequestAuditProfileDescribeRequest {
        let obj = Object.assign(new RequestAuditProfileDescribeRequest(), model);
        RequestAuditProfileDescribeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditProfileDescribeRequest>): RequestAuditProfileDescribeRequest {
        if (!model) return null;
        return RequestAuditProfileDescribeRequest.newInstance(<RequestAuditProfileDescribeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditProfileDescribeRequest) {
        if (!obj) return;

        models.RequestAuditProfileDescribeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditProfileDescribeRequest): boolean {
        if (models.RequestAuditBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RequestAuditProfileDescribeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
